import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import "./Marquee_Holder.css";
import { AppSetup } from "../../../utils/apis/common/Common";

const Marquee_Holder = () => {
  const [setups, setSetup] = useState();


  const getSetup = async () => {
    const res = await AppSetup();
    if (res?.success) {
      setSetup(res?.data);
    }
  };

  useEffect(() => {
    getSetup();
  }, []);
  return (
    <Marquee className="custom_tag" speed={80} direction="left">
      <span>
        {[...Array(3)].map((_, index) => (
          <span key={index} style={{ marginRight: "2rem" }}>
            {setups?.home_strip_line}
          </span>
        ))}
      </span>
    </Marquee>
  );
};

export default Marquee_Holder;
